/* Lotus Wheel hero slider — crossfade, scoped per instance.
   Optional autoplay (data-autoplay + data-speed), touch swipe, dots + arrows.
   Pauses on hover / touch; honours prefers-reduced-motion (no autoplay). */
class LotusHeroSlider extends HTMLElement {
  connectedCallback() {
    this.stage = this.querySelector('.hero-slider__stage');
    this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
    this.dots = Array.from(this.querySelectorAll('.hero-slider__dot'));
    if (this.slides.length < 2) return;

    this.index = 0;
    this.timer = null;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.autoplay = this.hasAttribute('data-autoplay') && !this.reduced;
    this.speed = parseInt(this.getAttribute('data-speed'), 10) || 5000;

    this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
    this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

    this.bindSwipe();

    if (this.autoplay) {
      this.start();
      this.stage.addEventListener('mouseenter', () => this.stop());
      this.stage.addEventListener('mouseleave', () => this.start());
    }
  }

  go(i) {
    const n = this.slides.length;
    this.index = ((i % n) + n) % n;
    this.slides.forEach((s, idx) => s.classList.toggle('is-active', idx === this.index));
    this.dots.forEach((d, idx) => d.classList.toggle('is-active', idx === this.index));
    if (this.autoplay) this.start();
  }

  start() {
    this.stop();
    this.timer = setTimeout(() => this.go(this.index + 1), this.speed);
  }

  stop() {
    clearTimeout(this.timer);
  }

  bindSwipe() {
    let startX = 0;
    this.stage.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      this.stop();
    }, { passive: true });
    this.stage.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) {
        this.go(dx > 0 ? this.index - 1 : this.index + 1);
      } else if (this.autoplay) {
        this.start();
      }
    }, { passive: true });
  }

  disconnectedCallback() {
    this.stop();
  }
}

customElements.define('lotus-hero-slider', LotusHeroSlider);
